module.exports = __webpack_public_path__ + "static/media/ribbon_r.b915f40f.svg";